import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Avis } from 'src/app/avis/models/Avis';
import { AvisService } from 'src/app/services/avis.service';

@Component({
  selector: 'app-list-avis',
  templateUrl: './list-avis.component.html',
  styleUrls: ['./list-avis.component.scss']
})
export class ListAvisComponent implements OnInit {

    listAvis: Avis[];
    avisSubscription: Subscription;


    constructor(private avisService: AvisService) { }

    /**
     * S'abonner à la liste d'avis
     */
    ngOnInit(): void {
        // Stocker la souscription à l'observable qui envoie les avis
        this.avisSubscription = this.avisService.avisSubject.subscribe(
            (avis: Avis[]) => {
                this.listAvis = avis;
            }
        );
        // Faire émettre l'observable qui envoie les avis pour mettre à jour la liste des avis
        this.avisService.emmitAvisSubject();
        console.log(this.listAvis);
    }
}
